var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 d-flex justify-center align-center"},[_c('h3',{staticClass:"gotham-black"},[_vm._v("Error 404")])])}]

export { render, staticRenderFns }